import {useTranslation} from "react-i18next";
import {default as PhInput} from "react-phone-input-2";
import {useField, useFormikContext} from "formik";
import {PropTypes} from "prop-types";

import QuestionItem from "../../utilities/QuestionItem";
import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

import "react-phone-input-2/lib/style.css";

const PhoneInput = ({
  label,
  width = "75%",
  className = "",
  question = null,
  autolabel,
  readOnly,
  disabled = false,
  labelWrap,
  labelStyles = {},
  dropdownStyles = {},
  inputStyles = {},
  style,
  required = false,
  isRequiredAccented = true,
  onBlur = () => {},
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,
  ...props
}) => {
  const {t} = useTranslation();
  const {setFieldValue, setFieldError} = useFormikContext();

  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  const [field, meta] = useField(props);
  const {i18n} = useTranslation();

  const country = i18n.language === "en" ? "us" : "ua";

  const placeholder = {
    ua: "+380 (95) 111-22-33 ",
    us: "+(1) - (XXX) - XXX - XXXX",
  };

  const inputStyle = {
    border: "0",
    borderBottom: "1px solid #e2e2e2",
    background: "transparent",
    width: "100%",
    ...inputStyles,
  };
  // const buttonStyle = {
  //   border: "0",
  //   background: "transparent",
  // };

  const onPhoneInputChange = (phone, country) => {
    isValid(phone, country);
    setFieldValue(props.name, phone);
  };

  const isValid = (value, country) => {
    const digitsOnly = value.replace(/\D/g, "");
    // console.log("digitsOnly :>> ", digitsOnly);
    let error = null;
    if (country.countryCode === "ua" && digitsOnly.length !== 12) {
      // Украина: 12 цифр (включая код страны)
      error = "Номер UA повинен містити 12 цифр";
    }

    if (country.countryCode === "us" && digitsOnly.length !== 11) {
      // США: 11 цифр (включая код страны)
      error = "US number must be 11 digits";
    }
    if (required || digitsOnly.length > country.dialCode.length) setFieldError(props.name, error);
    else {
      setFieldError(props.name, null);
    }
  };

  const defaultFieldValue = i18n.language === "en" ? "+(1)" : "+380";
  const labelText = label ? t(label) : "";
  const isRequiredMarkHighlighted = !field.value && !disabled && !readOnly && !isDisabledByRoutePermission;

  return (
    <div className={`project_input phoneInput ${labelWrap ? "" : "labelWrap"}`} style={{zIndex: 10}}>
      {label && (
        <label htmlFor={props.name} style={labelStyles} className={autolabel ? "autolabel" : ""}>
          {/* {typeof label === "string" ? `${t(label)}${required ? "*:" : ":"}` : t(label)} */}
          <span>
            {labelText}
            {required && (
              <span className={isRequiredAccented && isRequiredMarkHighlighted ? "required-asterisk" : ""}>*</span>
            )}
            :
          </span>
        </label>
      )}
      <div className="" style={{width: width, position: "relative", height: "1.5em", ...style}}>
        <div className={className}>
          <PhInput
            readOnly={readOnly || isDisabledByRoutePermission}
            autoComplete="off"
            preferredCountries={["ua", "us"]}
            value={field.value || defaultFieldValue}
            //   onBlur={() => {
            //     setRawValue(value);
            //   }}
            country={country}
            // onlyCountries={["ua", "us"]}
            // masks={{ua: '+380(dd) ddd-dd-dd', us: '+(1) - (XXX) - XXX - XXXX'}}
            onChange={onPhoneInputChange}
            onBlur={() => onBlur(field.value)}
            //  onChange={phone => setValue(phone)}
            placeholder={placeholder[country]}
            inputStyle={inputStyle}
            countryCodeEditable={true}
            enableSearch
            //   buttonStyle={buttonStyle}
            buttonClass={"country_btn"}
            disabled={disabled || isDisabledByRoutePermission}
            style={{
              ...(readOnly || disabled || isDisabledByRoutePermission ? {cursor: "default"} : {background: "white"}),
            }}
            searchStyle={{width: "87%"}}
            dropdownStyle={{overflowX: "hidden", ...dropdownStyles}}

            // inputProps={{
            //   onPaste: e => {
            //     console.log("e :", e);
            //     const pastedText = e.clipboardData.getData("text");
            //     console.log("pastedText :", pastedText);
            //   },
            // }}

            // defaultErrorMessage={"no no no"}
            // isValid={isValid}
          />
        </div>

        {meta.error ? <div className="error">{meta.error}</div> : null}
      </div>

      {question ? <QuestionItem title={question} /> : null}
    </div>
  );
};

PhoneInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  width: PropTypes.string,
  props: PropTypes.array,
  className: PropTypes.string,
  question: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  autolabel: PropTypes.bool,
  inputProps: PropTypes.object,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
};

export default PhoneInput;
